import { module } from 'stereomodularjs';
import LocomotiveScroll from 'locomotive-scroll';

export default class extends module {
    constructor(m) {
        super(m);

        this.gutenbergContent = [
            {
                selector: '.o-gutenberg .wp-block-heading, .o-gutenberg p, .o-gutenberg .wp-block-buttons, .o-gutenberg .wp-block-media-text__media, .o-gutenberg *:not(.o-parallax__img)>.wp-block-image, .o-gutenberg .wp-block-list, .o-gutenberg .o-button-sticky__wrapper, .o-gutenberg .wp-block-create-block-accordion-block, .o-gutenberg .wp-block-separator, .o-gutenberg .wp-block-table, .o-gutenberg .c-box-list-link-stroked__wrapper, .o-gutenberg .o-link-default, .o-gutenberg .c-slider-regroupement, .o-gutenberg .o-text h2, .o-gutenberg .o-text h3, .o-gutenberg .o-text h4, .o-gutenberg .o-text h5, .o-gutenberg .o-text h6, .o-gutenberg .o-text ul, .o-gutenberg .o-text ol, .o-gutenberg .c-box-files, .o-gutenberg .c-card, .o-gutenberg .c-box-cta .o-button',
                class: 'u-anim-opacity-up',
                data: 'data-scroll'
            },
        ];
    }

    init() {
        this.gutenbergContent.forEach((anim) => {
            const elements = document.querySelectorAll(anim.selector);
            elements.forEach((el) => {
                if (anim.class) {
                    el.classList.add(anim.class);
                }
                if (anim.data) {
                    el.setAttribute(anim.data, '');
                }
            });
        });

        function onScroll({ direction, scroll }) {
            if (scroll < 50) {
                document.querySelector('html').classList.remove('has-quicknav-hidden');
            } else {
                document.querySelector('html').classList.add('has-quicknav-hidden');
            }
        }

        window.locomotiveScroll = new LocomotiveScroll({
            lenisOptions: {
                smoothWheel: true, // Set to false to disable smoothScroll, but keep is-inview class triggering
                smoothTouch: false, // Disable on mobile devices
            },
            scrollCallback: onScroll,
        });

        window.locomotiveScroll.scrollTo(0, {
            duration: 0,
            lerp: 0,
        });

        // data-scroll-event-progress Example
        window.addEventListener('progressEvent', (e) => {
            const { target, progress } = e.detail;
            const percent = progress * 100;
            const percentRounded = Math.round(progress * 100);
            const progressEl = document.querySelector('.js-progress');
            const progressBarEl = document.querySelector('.js-progress-bar');

            if (progress && progressEl && progressBarEl) {
                progressEl.innerHTML = percentRounded + '%';
                progressBarEl.style.cssText += `width: ${percent}%;`;
            }
        });

        document.querySelector('html').classList.add('is-scroll-initialized');
    }

    destroy() {
        if (window.locomotiveScroll) {
            window.locomotiveScroll.destroy();
            window.locomotiveScroll = null;
        }
        window.removeEventListener('progressEvent', this.handleProgressEvent);
        document.querySelector('html').classList.remove('is-scroll-initialized');
    }
}
